import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'

import { makeSection, protoContainerLinksToLinks } from '../banner-section-builders'
import {
  buildWidgetTrackingMetaData,
  buildWidgetTrackingTypes,
  protoGenericContentToDomain,
  protoImageToDomain,
  toThemeType,
} from '../widget-utils'

import type { ProductShowcaseWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

export function buildProductShowcaseConfig(
  data: ProductShowcaseWidgetData,
  tracker?: string,
  sectionPosition?: number,
): CustomSection {
  return makeSection({
    id: data.id,
    sectionType: data.sectionType as CUSTOM_SECTION_TYPE,
    richTexts: data.richTexts as CustomSection['richTexts'],
    images: data.images.map(protoImageToDomain),
    imageLinks: protoContainerLinksToLinks(data.imageLinks),
    containerLinks: protoContainerLinksToLinks(data.containerLinks),
    genericContents: data.genericContents.map((generic, index) =>
      protoGenericContentToDomain(generic as Record<string, unknown>, index),
    ),
    themeType: toThemeType(data.themeType),
    classNames: data.classNames,
    classNamesMobileOverrides: data.classNamesMobileOverrides,
    baseDynamicClasses: data.baseDynamicClasses,
    mobileDynamicClassesOverrides: data.mobileDynamicClassesOverrides,
    tracker,
    elementPosition: sectionPosition,
    trackingMetaData: buildWidgetTrackingMetaData(data.analytics, sectionPosition),
    trackingTypes: buildWidgetTrackingTypes(data.analytics),
  })
}
